import {Component, EventEmitter, Input, Output} from "@angular/core";
import {Van} from "../../../../../../../../../../server/src/base/entities/leasing/Van";

@Component({
    selector: 'admin-van-details',
    styleUrls: ['./vanDetails.scss'],
    templateUrl: './vanDetails.html'
})
export class VanDetailsComponent {

    @Input() van:Van;
    @Output() enabled:EventEmitter<void> = new EventEmitter<any>();
    @Output() disabled:EventEmitter<void> = new EventEmitter<any>();
    @Output() removed:EventEmitter<void> = new EventEmitter<any>();

}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/leasing/presentation/vanEditComponent/vanDetails/vanDetails.ts